import {emptyObject} from '@packages/utilities/fp/utils';

export type SomeT = {
  tag: 'Some';
  val: unknown;
};
export type NoneT = {
  tag: 'None';
  val: Record<any, any>;
};

export const Some = (val: unknown): SomeT => ({tag: 'Some', val});
export const None: NoneT = {tag: 'None', val: emptyObject};
